import { useQuery } from "urql";

import {
  GetTenantsDocument,
  TenantFilter,
  TenantOrderBy,
} from "../../../graphql/generated.ts";
import { getApiPaginationData } from "../../../utils/api.ts";
import { ApiHookProps } from "../types.ts";

export function useTenants({
  filter,
  orderBy,
  pause,
  page,
}: ApiHookProps<TenantFilter, TenantOrderBy>) {
  const pagination = getApiPaginationData(page);
  const variables = {
    filter,
    orderBy,
    skip: pagination?.skip,
    take: pagination?.take,
  };
  return useQuery({
    query: GetTenantsDocument,
    variables,
    pause,
  });
}
